/*
 * 文件EN: APIAuthorize.js,
 * 文件CN: api授权,
 * 创建时间: Wednesday, 17th June 2020 9:50:50 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'

/**
 * @desc 列表获取
 * @method GET
 * @param {参数说明 详细见 swagger}
 */
export const getListData = params => {
  return request.get('/apiManager/api/queryCallerInfoList', params)
}

/**
 * @desc 详情
 * @method GET
 * @param {callerCode 调用方编号 String}
 */
export const fetchDetails = params => {
  return request.get('/apiManager/api/queryCallerInfoDetail', params)
}

/**
 * @desc 新建调用方
 * @method POST
 * @param {参数说明 详细 见swagger}
 */
export const create = params => {
  return request.post('/apiManager/api/createCaller', params, { json: true })
}

/**
 * @desc 调用方修改信息
 * @method POST
 * @param {参数说明 详细 见swagger}
 */
export const update = params => {
  return request.post('/apiManager/api/callerUpdate', params, { json: true })
}
